// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"0dfc5c43","95":"b3da96ed","433":"7b6381f8","478":"430ebca0","480":"105de9ca","482":"be9ce067","488":"98ff5b06","608":"22b0d034","744":"4f2f1577","797":"a67edd5f","919":"f785071f","951":"5781d894"}[chunkId] + ".chunk.js";
};